import { Schema } from "effect";

export const EnrollmentCallGapSegment = Schema.Struct({
  startMinute: Schema.Number,
  endMinute: Schema.Number,
  kind: Schema.Literals(["call", "gap"]),
  gapType: Schema.NullOr(Schema.Literals(["before", "between", "after", "no_calls"])),
});
export type EnrollmentCallGapSegment = typeof EnrollmentCallGapSegment.Type;

export const EnrollmentCallGapDay = Schema.Struct({
  specialistId: Schema.String,
  specialistName: Schema.String,
  date: Schema.String,
  shiftStartMinute: Schema.NullOr(Schema.Number),
  shiftEndMinute: Schema.NullOr(Schema.Number),
  calls: Schema.Number,
  callMinutes: Schema.Number,
  nonCallMinutes: Schema.Number,
  longGapMinutes: Schema.Number,
  longGapCount: Schema.Number,
  segments: Schema.Array(EnrollmentCallGapSegment),
});
export type EnrollmentCallGapDay = typeof EnrollmentCallGapDay.Type;

export const EnrollmentCallGapsResponse = Schema.Struct({
  start: Schema.String,
  end: Schema.String,
  specialist: Schema.NullOr(Schema.String),
  weekdaysOnly: Schema.Boolean,
  timezone: Schema.Literal("America/New_York"),
  generatedAt: Schema.String,
  source: Schema.Literal("live"),
  specialists: Schema.Array(Schema.Struct({ id: Schema.String, name: Schema.String })),
  days: Schema.Array(EnrollmentCallGapDay),
});
export type EnrollmentCallGapsResponse = typeof EnrollmentCallGapsResponse.Type;

export type EnrollmentCallGapsParams = {
  start: string;
  end: string;
  specialist?: string;
  weekdaysOnly?: boolean;
};
